import React from 'react'

import { Avatar, Box, Link, TableCell, TableRow, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CollegeCrest from '@scoir/college-crest'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  rowStyles: {
    '& .MuiTableCell-sizeSmall:last-child': {
      paddingRight: '24px',
    },
  },
  competitorRank: {
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.black,
    fontWeight: theme.typography.fontWeightLight,
  },
  collegeCrestBox: {
    display: 'flex',
    alignItems: 'center',
  },
  collegeCrest: {
    height: 40,
    width: 40,
    marginRight: theme.spacing(2),
  },
}))

const CompetitorTableBody = ({ competitors, rowsPerPage, rowHeight, currentPage, emptyRows, classNames }) => {
  const styles = useStyles()
  const getRank = (index) => index + currentPage * rowsPerPage + 1
  const ROOT_PATH = import.meta.env.BASE_URL

  return (
    <React.Fragment>
      {competitors
        .slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
        .map((competitor, index) => (
          <TableRow
            key={competitor.sc_id}
            className={styles.rowStyles}
          >
            <TableCell
              size="small"
              className={classNames.smallCell}
            >
              <Avatar className={styles.competitorRank}>
                <Typography variant="body2">{getRank(index)}</Typography>
              </Avatar>
            </TableCell>
            <TableCell size="small">
              <Box className={styles.collegeCrestBox}>
                <CollegeCrest
                  scid={competitor.sc_id}
                  className={styles.collegeCrest}
                  alt={`${competitor.name} logo`}
                />
                <Typography>
                  <Link href={`${ROOT_PATH}/colleges/${competitor.sc_id}`}>{competitor.name}</Link>
                </Typography>
              </Box>
            </TableCell>
            <TableCell
              size="small"
              align="right"
            >
              {competitor.mutual_prospect_count.toLocaleString()}
            </TableCell>
            <TableCell
              size="small"
              align="right"
              className={classNames.extraPadding}
            >
              {competitor.total_prospect_count.toLocaleString()}
            </TableCell>
          </TableRow>
        ))}
      {emptyRows > 0 && (
        <TableRow
          aria-hidden="true"
          style={{ height: rowHeight * emptyRows }}
        >
          <TableCell
            size="small"
            colSpan={12}
          />
        </TableRow>
      )}
    </React.Fragment>
  )
}

CompetitorTableBody.propTypes = {
  competitors: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  rowHeight: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  emptyRows: PropTypes.number.isRequired,
  classNames: PropTypes.object,
}

export default CompetitorTableBody
